import React, { Component } from "react";
import PropTypes from "prop-types";
import BaseModal from "components/ModalContainer/BaseModal";
import {
  getConfirmActionMessageForType,
  progressiveVerbs
} from "constants/modalMessages";
import { modalStatuses, PUBLISH_ACTIONS } from "constants/modalStatuses";
import { INSTALL_MODAL } from "constants/globals";
import "components/ModalContainer/PublishingModal/style.scss";

export default class PublishingModal extends Component {
  static propTypes = {
    publishToApi: PropTypes.func.isRequired,
    onAction: PropTypes.func.isRequired
  };

  state = {
    requestState: modalStatuses.PROMPT
  };

  launchInstallModal = () => {
    const { actions } = this.props;
    actions.showModal(INSTALL_MODAL, {});
  };

  handleOk = () => {
    const {
      accountApiKey,
      accountId,
      currentContent,
      publishActionType,
      stepId,
      userId,
      publishToApi,
      onAction
    } = this.props;

    const data = {
      account_id: accountId,
      account_api_key: accountApiKey,
      content_id: stepId,
      content_type: currentContent.type,
      user_id: userId
    };

    if (publishActionType === PUBLISH_ACTIONS.REVERT) {
      data["to_version_id"] = currentContent.updatedAt;
    }

    this.setState({ requestState: modalStatuses.PENDING });
    return publishToApi(publishActionType, data)
      .then(response => {
        onAction(publishActionType, data);
        this.setState({ requestState: modalStatuses.SUCCESS });
        return response;
      })
      .catch(() => {
        this.setState({ requestState: modalStatuses.ERROR });
        throw new Error();
      });
  };

  render() {
    const {
      currentContent,
      isInstalled,
      publishActionType,
      renderPrompt
    } = this.props;
    const { requestState } = this.state;

    const shouldShowInstallModal =
      !isInstalled && publishActionType === PUBLISH_ACTIONS.PUBLISH;
    const name =
      currentContent.type === "checklist"
        ? currentContent.internalName
        : currentContent.name;

    switch (requestState) {
      case modalStatuses.ERROR:
        return (
          <BaseModal okText="Okay" {...this.props}>
            <h2 className="confirm-message">{`Error publishing ${name}.\n`}</h2>
            <p>
              {`Please check your internet connection. If the problem persists, contact support.`}
            </p>
          </BaseModal>
        );

      case modalStatuses.PENDING:
        return (
          <BaseModal modalClass="pending-modal" {...this.props}>
            <h2 className="confirm-message">{`${progressiveVerbs[publishActionType]} ${name}`}</h2>
          </BaseModal>
        );

      case modalStatuses.PROMPT:
        return (
          <BaseModal
            okText="Continue"
            modalClass="confirm-modal"
            onClickOK={this.handleOk}
            afterHandleOk={
              shouldShowInstallModal ? this.launchInstallModal : null
            }
            {...this.props}
          >
            {renderPrompt ? (
              renderPrompt(currentContent, publishActionType)
            ) : (
              <h2 className="confirm-message">
                {getConfirmActionMessageForType(
                  publishActionType,
                  currentContent.type
                )}
              </h2>
            )}
          </BaseModal>
        );

      default:
        return <div />;
    }
  }
}
